module.exports = __webpack_public_path__ + "static/media/icon3.c50beac9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/LAMI/icon3.svg
// module id = 94
// module chunks = 0